<template>
    <div class="pharmacy-workstation">
        <el-form ref="form" :model="filters" label-width="80px" inline>
            <el-form-item label="处方编号" prop="orderNo">
                <el-input v-model="filters.orderNo" placeholder="请输入处方编号"></el-input>
            </el-form-item>
            <el-form-item label="处方类型" prop="orderType">
                <el-select v-model="filters.orderType" placeholder="请选择">
                    <el-option
                            v-for="item in types"
                            :value="item.value"
                            :key="item.value"
                            :label="item.label"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开方医院" prop="hosId">
                <el-select v-model="filters.hosId" placeholder="请选择">
                    <el-option
                            v-for="item in hospitalList"
                            :key="item.id"
                            :label="item.hosName"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开方医生" prop="docName">
                <el-input v-model="filters.docName" placeholder="请输入开方医生"></el-input>
            </el-form-item>
            <el-form-item label="患者姓名" prop="compatName">
                <el-input v-model="filters.compatName" placeholder="请输入患者姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="resetForm('form')">重置</el-button>
                <el-button type="primary" @click="getList">筛选</el-button>
            </el-form-item>
        </el-form>
        <el-radio-group v-model="checkedStatus">
            <el-radio-button v-for="state in states" :label="state.label" :key="state.text">{{state.text}}
            </el-radio-button>
        </el-radio-group>
        <el-table :data="list" v-loading="loading" border>
            <el-table-column prop="orderNo" label="处方编号" width="180"></el-table-column>
            <el-table-column prop="status" :formatter="formatterStatus" label="处方状态"></el-table-column>
            <el-table-column prop="orderType" :formatter="formatterOrderType" label="处方类型"></el-table-column>
            <el-table-column
                    prop="prescribingInformation"
                    :formatter="formatterPrescribingInformation"
                    label="处方信息"
                    width="120"
            ></el-table-column>
            <el-table-column prop="hosName" label="开方医院"></el-table-column>
            <el-table-column prop="docName" label="开方医生"></el-table-column>
            <el-table-column prop="createTime" :formatter="formatTime" label="开方时间"></el-table-column>
            <el-table-column prop="auditorName" label="审核药师"></el-table-column>
            <el-table-column prop="auditTime" :formatter="formatTime" label="审核时间"></el-table-column>
            <el-table-column prop="compatName" label="患者姓名"></el-table-column>
            <el-table-column prop="compatGender" :formatter="formatterCompatGender" label="患者性别"></el-table-column>
            <el-table-column prop="compatAge" label="患者年龄"></el-table-column>
            <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="getDetail(scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="pagination-wrapper" type="flex" justify="end">
            <el-pagination
                    layout="prev, pager, next"
                    :current-page.sync="page.pageNum"
                    :total="page.total"
                    @current-change="onCurrentChange"
            ></el-pagination>
        </el-row>
        <pharmacy-workstation-detail :detailInfo="detailInfo" :visible.sync="visible"></pharmacy-workstation-detail>
    </div>
</template>

<script>
  import {timeFormat} from "ty-vue-filters";
  import axiosUtil from "../../utils/AxiosUtils";
  import {formatStatus} from "../../utils/pharmacy";
  import {ORDER_TYPE_LIST} from "../../lib/config"
  import PharmacyWorkstationDetail from "./detail";

  import {sex} from "ty-vue-filters";

  const PAGE = {
    pageNum: 1,
    pageSize: 10,
    pages: 1,
    total: 0
  };
  export default {
    data() {
      return {
        visible: false,
        filters: {
          orderNo: "",
          orderType: "",
          docName: "",
          compatName: "",
          hosId: ""
        },
        hospitalList: [],
        status: [
          {
            value: "",
            label: "全部"
          },
          {
            value: "WAITTAKE",
            label: "待自取"
          },
          {
            value: "COMPLETE",
            label: "已完成"
          }
        ],
        types: ORDER_TYPE_LIST,
        detailInfo: {},
        list: [],
        states: [
          {
            label: "",
            text: "全部"
          },
          {
            label: "WAITTAKE",
            text: "待自取"
          },
          {
            label: "COMPLETE",
            text: "已完成"
          }
        ],
        loading: false,
        page: PAGE,
        checkedStatus: ""
      };
    },
    components: {
      PharmacyWorkstationDetail
    },
    watch: {
      visible(status) {
        if (!status) {
          this.getList();
        }
      },
      checkedStatus: {
        handler() {
          this.pages = PAGE;
          this.getList();
        },
        immediate: true
      }
    },
    methods: {
      getDetail(row) {
        axiosUtil(
          {
            service: "smarthos.recipe.order.info",
            orderId: row.id,
            token: localStorage.getItem("token")
          },
          ({code, obj, msg}) => {
            if (code === "0") {
              this.visible = true;
              this.detailInfo = Object.assign(obj, {hosName: row.hosName});
            } else {
              this.$message.error(msg);
            }
          }
        );
      },
      formatTime(row, column, time) {
        return timeFormat(time, "%Y/%m/%d %H:%M");
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      onSubmit() {
        this.getList();
      },
      onCurrentChange(pageNum) {
        this.page.pageNum = pageNum;
        this.getList();
      },
      getList() {
        this.loading = true;
        axiosUtil(
          {
            status: this.checkedStatus,
            service: "smarthos.recipe.order.pharmacist.list.page",
            token: localStorage.getItem("token"),
            ...this.page,
            ...this.filters
          },
          ({code, list, page, msg}) => {
            if (code === "0") {
              this.loading = false;
              this.list = list;
              this.page = page;
            } else {
              this.$message.error(msg);
            }
          }
        );
      },
      formatterCompatGender(row, column, code) {
        return sex(code, 2);
      },
      formatterStatus({takeMode}, column, status) {
        return formatStatus(takeMode, status);
      },
      formatterOrderType(row, column, code) {
        const typeObj = {
          WESTERN_RECIPE: "西药方",
          CHINESE_RECIPE: "中药方"
        };
        return typeObj[code];
      },
      formatterPrescribingInformation({drugCount, totalPrice}) {
        return `${drugCount}种药品 ${totalPrice / 100}元`;
      },
      getAuthorities() {
        axiosUtil({
          service: 'smarthos.system.hos.list',
          token: localStorage.getItem("token")
        }, ({code, list = [], msg}) => {
          if (code === '0') {
            this.hospitalList = list;
          } else {
            this.$message.error(msg);
          }
        });
      }
    },
    created() {
      this.getAuthorities();
    }
  };
</script>

<style lang="scss">
    .pharmacy-workstation {
        .el-table {
            margin-top: 15px;
        }
        .pagination-wrapper {
            padding: 20px 0;
        }
        .el-table .cell {
            max-height: 69px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }
</style>
